import { css } from 'linaria';
import { sendEvent } from 'model/helpers/events.model';
import { useLocalization } from 'model/localization.model';
import { h } from 'preact';
import { ErrorLayout } from 'features/verify/ui/error-layout';
import { useState } from 'preact/hooks';
import { Button } from 'ui/atoms/button';
import { Link } from 'ui/atoms/link';
import { Text } from 'ui/typography';

const subClass = css`
	text-align: center;
	margin-bottom: auto;
`;

export const AccessDenied = () => {
	const t = useLocalization();
	const [start] = useState(Date.now());

	return (
		<ErrorLayout
			title={t('mobile.camera.denied.title')}
			description={t('mobile.camera.denied.description')}
		>
			<Link
				href={t('mobile.camera.denied.description.url')}
				target={'_blank'}
				className={subClass}
			>
				{t('mobile.camera.denied.description.sub')}
			</Link>
			<Text
				style={{
					textAlign: 'center',
					marginBottom: 32,
				}}
			>
				{t('mobile.camera.denied.hint')}
			</Text>
			<Button
				name={'mobile.camera.denied.btn'}
				onClick={() => {
					sendEvent({
						event: 'camera_error_refresh_clicked',
						event_attributes: { duration: Date.now() - start },
					});
					window.location.reload();
				}}
			>
				{t('mobile.camera.denied.btn')}
			</Button>
		</ErrorLayout>
	);
};
